module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kQDlD"))).then(() => parcelRequire('d0iPb'));